<template>
    <div>
        <form
            role='form'
            method='POST'
            @submit.prevent="handleLogin"
        >
            <input
                id='email'
                v-model='user.email'
                type='email'
                name='email'
                placeholder='E-mailadres'
                required
            >

            <input
                id='password'
                v-model='user.password'
                type='password'
                name='password'
                placeholder='Wachtwoord'
                required
            >

            <button
                class='btn wide '
                :disabled='loading || (!user.email || !user.password)'
                @click='handleLogin'>
                Inloggen
            </button>

            <span
                class='error-message'
                v-if='errorMessage && errorMessage.length > 0'
            >
                {{ errorMessage }}
            </span>
        </form>
    </div>
</template>

<script>
import {
    mapActions,
} from "vuex";

export default {
    name: "LoginForm",
    data() {
        return {
            user: {
                email: "",
                password: "",
            },
            hasError: false,
            loading: false,
            errorMessage: "",
        };
    },
    methods: {
        ...mapActions("user", [
            "login",
        ]),
        handleLogin() {
            this.errorMessage = "";
            this.loading = true;

            if (this.user.email.length > 0 && this.user.password.length > 0) {
                this.login({...this.user})
                    .then(() => {
                        if (this.$route.query.hasOwnProperty("redirect")) {
                            return this.$router.push({
                                path: this.$route.query.redirect,
                            });
                        }

                        return this.$router.push({
                            name: "pages.home",
                        });
                    })
                    .catch(_ => {
                        this.errorMessage = "Deze combinatie van e-mailadres en wachtwoord is niet gevonden.";
                        this.hasError = true;
                        this.loading = false;
                    });
            } else {
                this.errorMessage = "Vul alle velden in.";
            }
        },
    },
};
</script>
